import { BaseProduct } from '@/ui/services/BaseProductService';

export type AddProductWithBundleParams = {
  product: BaseProduct;
  variantSKU?: string;
  bundleExtRef?: string;
  bundleProductSKUs?: string[];
  nukiIds?: string[];
  quantity: number;
  directPurchase?: boolean;
};

/**
 * Adds a product to the cart, optionally pre-selecting an attached bundle and its
 * child variants. Returns false when the requested variant can't be resolved.
 *
 * Mutates the cart store via product.addToCart — does not return new state.
 */
export const addProductWithBundleToCart = (params: AddProductWithBundleParams): boolean => {
  const {
    product,
    variantSKU,
    bundleExtRef,
    bundleProductSKUs,
    nukiIds,
    quantity,
    directPurchase,
  } = params;

  const initialVariant = variantSKU
    ? product.getVariantBySKU(variantSKU)
    : product.getDefaultVariant();
  if (!initialVariant) {
    return false;
  }

  const selectedBundle = bundleExtRef
    ? product.findAttachedBundleByExtRef(bundleExtRef)
    : undefined;

  const selectedBundleProductVariants =
    selectedBundle && bundleProductSKUs?.length
      ? selectedBundle.selectVariantsBySKUs(bundleProductSKUs)
      : selectedBundle?.defaultBundleProductVariants;

  product.addToCart(initialVariant, {
    nukiIds,
    directPurchase,
    quantity,
    selectedBundle,
    selectedBundleProductVariants,
    ...(bundleExtRef && nukiIds?.[0] ? { upgradeProgramDeviceId: nukiIds[0] } : {}),
  });

  return true;
};
